import { render } from "./fuyiz.vue?vue&type=template&id=a7ee25b2&scoped=true"
import script from "./fuyiz.vue?vue&type=script&lang=js"
export * from "./fuyiz.vue?vue&type=script&lang=js"

import "./fuyiz.vue?vue&type=style&index=0&id=a7ee25b2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7ee25b2"]])

export default __exports__